module.exports = __webpack_public_path__ + "img/m6.3709dff6.png";